export enum NETTING_TYPE {
    WM = 'wm',
    ACT = 'act',
    NONE = 'none',
    BALANCE = 'affiliate_balance',
}
